"use client"

import { useState } from "react"
import { FaMagnifyingGlass } from "react-icons/fa6"

const sports = [
  {
    name: "search",
    sports_key: ["all"],
    title: "All Games",
    // Reuse the same icon as the current "All" button.
    icon: (
      <img
        className="w-[20px]"
        alt="All games"
        src={require("../assets/MenuImages/sports_video.png") || "/placeholder.svg"}
      />
    ),
  },
  {
    name: "baseball",
    sports_key: ["baseball_mlb"],
    title: "Baseball",
    icon: (
      <img
        className="w-[20px]"
        alt="Baseball"
        src={require("../assets/MenuImages/sports_soccer.png") || "/placeholder.svg"}
      />
    ),
  },
  {
    name: "basketball",
    sports_key: ["basketball_nba", "basketball_ncaab", "basketball_wnba", "basketball_wncaab"],
    title: "Basketball",
    icon: (
      <img
        className="w-[20px]"
        alt="Basketball"
        src={require("../assets/MenuImages/sports_basketball.png") || "/placeholder.svg"}
      />
    ),
  },
  {
    name: "american-boxing_boxing",
    sports_key: ["american-boxing_boxing", "boxing_boxing", "Boxing"],
    title: "Boxing",
    icon: (
      <img
        className="w-[20px]"
        alt="Boxing"
        src={require("../assets/MenuImages/sports_mma.png") || "/placeholder.svg"}
      />
    ),
  },
  {
    name: "american-football",
    sports_key: [
      "nfl",
      "american-football",
      "americanfootball_ncaaf",
      "americanfootball_cfl",
      "americanfootball_ncaaf",
      "americanfootball_nfl",
      "americanfootball_nfl_preseason",
      "americanfootball_nfl_super_bowl_winner",
    ],
    title: "Football",
    icon: (
      <img
        className="w-[20px]"
        alt="Football"
        src={require("../assets/MenuImages/sports_football-1.png") || "/placeholder.svg"}
      />
    ),
  },
  {
    name: "golf",
    sports_key: ["Golf"],
    title: "Golf",
    icon: (
      <img
        className="w-[20px]"
        alt="Golf"
        src={require("../assets/MenuImages/sports_tennis.png") || "/placeholder.svg"}
      />
    ),
  },
  {
    name: "mma",
    sports_key: ["MMA", "mma_mixed_martial_arts"],
    title: "MMA",
    icon: (
      <img
        className="w-[20px]"
        alt="MMA"
        src={require("../assets/MenuImages/sports_martial_arts.png") || "/placeholder.svg"}
      />
    ),
  },
  {
    name: "tennisball-outline",
    sports_key: ["Tennis"],
    title: "Tennis",
    icon: (
      <img
        className="w-[20px]"
        alt="Tennis"
        src={require("../assets/MenuImages/sports_tennis.png") || "/placeholder.svg"}
      />
    ),
  },
]

function SportsList({ onSelectSport, onSearch }) {
  const [selectedTitle, setSelectedTitle] = useState("All Games")
  const [query, setQuery] = useState("")

  const handleSearchChange = (nextValue) => {
    setQuery(nextValue)
    if (onSearch) onSearch(nextValue)
  }

  return (
    <div className="flex flex-col space-y-2 min-h-full bg-gray-900/80 backdrop-blur-sm rounded-xl p-4 border border-gray-800">
      <div className="w-full items-center flex p-2 mb-4 rounded-full bg-gray-800/70 text-white">
        <span className="px-3 border-none">
          <FaMagnifyingGlass size={12} color="white" />
        </span>
        <input
          type="text"
          placeholder="Search"
          className="bg-transparent w-full focus:outline-none"
          value={query}
          onChange={(e) => handleSearchChange(e.target.value)}
          aria-label="Search games"
        />
      </div>

      <div className="border-t border-gray-800 my-2"></div>

      {sports.map((sport) => (
        <button
          key={sport.title}
          className={`flex items-center space-x-4 p-3 transition-colors rounded-lg ${
            selectedTitle === sport.title ? "bg-emerald-500/10 border border-emerald-500/30" : "hover:bg-gray-800/50"
          }`}
          onClick={() => {
            setSelectedTitle(sport.title || "All")
            onSelectSport(sport.sports_key, sport.title || "All")
          }}
        >
          <div className={`${selectedTitle === sport.title ? "bg-emerald-500/20" : "bg-gray-800/70"} p-2 rounded-lg`}>
            {sport.icon}
          </div>

          <span className="text-base text-white font-medium">{sport.title}</span>
        </button>
      ))}
    </div>
  )
}

export default SportsList

